const API = {
  G50PLUS: "G50PLUS",
  D60: "D60",
  D90: "D90pro",
  ED60: "ED60",
  EG50: "EG50",
  EV80: "EV69",
  G10: "G10102",
  G20: "G20102",
  G50: "G50502",
  MD60: "MD60",
  MG50: "MG50",
  MV80: "V80862",
  RG20: "RG20",
  RV90B: "R63B",
  RV90C: "R63C",
  RV80B: "R6161B",
  RV80C: "R6261C",
  T60: "T60602",
  T70: "T70",
  T70PRO: "T70PRO",
  V80: "V80802",
  V90: "V80882",
  EV90: "EV90",
  EV30: "EV31",
  T90: "T90",
  RX30: "RX30",
  星际H: '星际H',
  星际R: '星际R',
  星际L: '星际L',
  星际X: '星际X',
  星际XEV: '星际XEV',
  newEnergy: {
    G50PLUS: "G50PLUS",
    D60: "D60",
    D90: "D90",
    ED60: "EUNIQ 6",
    EG50: "EUNIQ 5",
    EV80: "EV69",
    G10: "G10",
    G20: "G20",
    G50: "G50",
    MD60: "EUNIQ 6 PLUG IN",
    MG50: "EUNIQ 5 PLUG IN",
    MV80: "V80862",
    RG20: "RG20",
    RV90B: "RV90B",
    RV90C: "RV90C",
    T60: "T60",
    T70: "T70",
    T70PRO: "T70PRO",
    V80: "V80",
    V90: "V90",
    EV90: "EV90",
    RV80B: "RV80B",
    RV80C: "RV80C",
    EV30: "EV30",
    T90: "T90",
    RX30: "RX30",
    星际H: '星际H',
    星际R: '星际R',
    星际L: '星际L',
    星际X: '星际X',
    星际XEV: '星际XEV'
  }
}

export default API;
